// NPM
import React from 'react'

const Hero = ({ section }) => {

  if(!section) {
    return null
  }

  return (
    <div className="Hero">
      <h1 className="Hero__title">
        { section.title }
      </h1>
    </div>
  )

}

export default Hero